import React from 'react'
import PrivatePageSF from '../../templates/PrivatePageSF.js'
import PageTitleUI from '../../widgets/output/PageTitleUI'
import AlertRuleCreateOrUpdateSF from '../../components/projectapp/alertRule/AlertRuleCreateOrUpdateSF'

const AlertRuleCreatePageUI = ({context, project, messageList}) =>
  <PrivatePageSF context={context} className='pg_alrt_crt'
    backLink={project ? `/projects/${project.projectId}/alerts` : ''}
    messageList={messageList} headerMessageKey='c_alert_rule'
    subHeaderText={`${project ? project.projectName : ''}`}
  >
    <PageTitleUI context={context} goBack={true}
      backLink={project ? `/projects/${project.projectId}/alerts` : ''}
      messageList={messageList} titleMessageKey='c_alert_rule'
      subTitleText={`${project && project.projectName}`}
    />

    <AlertRuleCreateOrUpdateSF context={context} messageList={messageList} project={project} />
  </PrivatePageSF>

export default AlertRuleCreatePageUI
